import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Datatable from '../controls/Datatable.jsx';
import DatatablesCallbacks from '../../datatables/DatatablesCallbacks';

class Paises extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.PAISES)
            return null;

        const token = this.props.token;

        const editorFields = [
            { "label": "Nome", "name": "name" }
        ];

        const datatablesColumns = [
            { data: "name", title: "Nome", render: $.datatable.renders.text() },
            { data: "dateCreated", title: "Criação", render: $.datatable.renders.datetime(), width: 160 },
            { data: "dateUpdated", title: "Edição", render: $.datatable.renders.datetime(), width: 160 },
        ];

        let callbacks = new DatatablesCallbacks({
            token: token,
            selectUrl: '/api/countries/select',
            createUrl: '/api/countries/insert',
            editUrl: '/api/countries/update/_id_',
            removeUrl: '/api/countries/delete/_id_',
        });

        const editorCreateTitle = 'Inserir país';
        const editorEditTitle = 'Editar país';
        const editorRemoveTitle = 'Remover país';
        const editorRemoveMessage = 'Deseja remover este país?';

        const domClassName = 'countries-datatables';
        const title = 'Países';
        const subTitle = 'Gerenciamento';

        return (
            <Datatable DomClassName={domClassName}
                       title={title}
                       subTitle={subTitle}
                       responsive={true}
                       editorCreateVisible={true}
                       editorCreate={callbacks.create.bind(callbacks)}
                       editorCreateTitle={editorCreateTitle}
                       editorEditVisible={true}
                       editorEdit={callbacks.edit.bind(callbacks)}
                       editorEditTitle={editorEditTitle}
                       editorRemoveVisible={true}
                       editorRemove={callbacks.remove.bind(callbacks)}
                       editorRemoveTitle={editorRemoveTitle}
                       editorRemoveMessage={editorRemoveMessage}
                       editorFields={editorFields}
                       datatablesSelect={callbacks.select.bind(callbacks)}
                       datatablesColumns={datatablesColumns}
            />
        );
    }
}

export default Paises;


// WEBPACK FOOTER //
// src/views/pages/Paises.jsx